/* eslint-disable no-use-before-define */
/* eslint-disable no-await-in-loop */
import moment from 'moment';
import { mobileFormFieldsTypes, textfieldTypes } from '../../../config/constants/mobileFormConstant';

export async function getResultStructure(form, values, options = {}) {
  if (!form?.length) return [];

  const resultForm = [];
  for (let i = 0; i < form.length; i += 1) {
    const page = form[i];
    const fields = await getFieldsValues(page.list, values, options);
    resultForm.push({
      page: String(i),
      label: page.label,
      fields,
    });
  }
  return resultForm;
}

async function getFieldsValues(fields, values, options) {
  const resultFields = [];
  for (const field of fields) {
    const fieldData = await handleField(field, values?.[field.idInput], options);
    if (fieldData != null) {
      resultFields.push(fieldData);
    }
  }
  return resultFields;
}

async function handleField(field, value, options) {
  const fieldData = fieldHandlers[field.id];
  if (fieldData == null) return null;

  const handlerResult = await fieldData.handler(field, value, options);
  return {
    id: field.id,
    idInput: field.idInput,
    label: field.label,
    type: fieldData.resultType,
    alert: field.alert,
    ...handlerResult,
  };
}

function handleTextField(field, value) {
  const fieldHandlers = {
    [textfieldTypes.TEXT.id]: { resultType: textfieldTypes.TEXT.name, handler: getTextValue },
    [textfieldTypes.CURRENCY.id]: { resultType: textfieldTypes.CURRENCY.name, handler: getTextValue },
    [textfieldTypes.NUMBER.id]: { resultType: textfieldTypes.NUMBER.name, handler: getTextValue },
    [textfieldTypes.DATE.id]: { resultType: textfieldTypes.DATE.name, handler: getDate },
    [textfieldTypes.DATETIME.id]: { resultType: textfieldTypes.DATETIME.name, handler: getDatetime },
    default: { resultType: textfieldTypes.TEXT.name, handler: getTextValue },
  };
  const inputTypeId = field.typeTextField?.id ?? field.typeTextField;
  const fieldData = fieldHandlers[inputTypeId] ?? fieldHandlers.default;
  return {
    typeTextField: fieldData.resultType,
    value: fieldData.handler(value),
  };
}

function getDatetime(value) {
  return moment(value).locale('en').format('MMM D, YYYY h:mm A');
}

function getDate(value) {
  return moment(value).locale('en').format('MMM D, YYYY h:mm A');
}

function getTextValue(value) {
  return value?.trim?.();
}

async function handleRadioField(field, value, options) {
  const resultRadios = [];
  if (field.list?.length) {
    for (const radioItem of field.list) {
      const item = await getRadioItemValue(radioItem, value, options);
      if (item.valueConditional instanceof Promise) {
        item.valueConditional = await item.valueConditional;
      }
      resultRadios.push(item);
    }
  }
  return {
    value: resultRadios,
  };
}

function getRadioItemValue(radioItem, value, options) {
  const result = {
    id: radioItem.id,
    idInput: radioItem.idInput,
    label: radioItem.label,
    value: value?.idInput === radioItem.idInput,
    alert: radioItem.alert,
  };
  if (result.value && radioItem.conditional && radioItem.list) {
    result.valueConditional = getFieldsValues(radioItem.list, value.valueConditional, options);
  }
  return result;
}

function handleListField(field, value) {
  const result = {
    type: field.multiple ? mobileFormFieldsTypes.listMultiple.value : mobileFormFieldsTypes.list.value,
  };
  if (value?.nodes?.length) {
    const resultValue = getListFieldValue(value, [value.title]);
    if (field.multiple) {
      result.value = resultValue;
    } else {
      result.value = resultValue.length ? resultValue[0].join(' > ') : null;
    }
  }
  return result;
}

function getListFieldValue(node, parents = [], resultItems = []) {
  for (const item of node.nodes) {
    if (item.nodes?.length) {
      resultItems = getListFieldValue(item, [...parents, item.title], resultItems);
    } else if (item.checked) {
      resultItems.push([...parents, item.title]);
    }
  }
  return resultItems;
}

function handleCheckboxField(field, value) {
  const resultValue = [];
  if (field.list?.length) {
    for (const item of field.list) {
      resultValue.push({
        idInput: item.idInput,
        label: item.label,
        alert: item.alert,
        value: value?.[item.idInput],
      });
    }
  }
  return {
    value: resultValue,
  };
}

function handleAssetField(_, value) {
  return {
    value: value?._id,
    valueObject: value,
  };
}

function handleActionField(field, value) {
  const actionTypes = {
    [mobileFormFieldsTypes.locationDate.typeAction]: mobileFormFieldsTypes.locationDate,
    [mobileFormFieldsTypes.action.typeAction]: mobileFormFieldsTypes.action,
    [mobileFormFieldsTypes.emails.typeAction]: mobileFormFieldsTypes.emails,
  };
  const actionType = actionTypes[field.typeAction.id];
  if (actionType == null) return null;
  return {
    typeAction: {
      id: actionType.typeAction,
    },
    type: actionType.value,
    value,
  };
}

async function handleLoopField(field, value, options) {
  const resultValue = [];
  if (field.list?.length && value?.length) {
    for (let i = 0; i < value.length; i += 1) {
      const fields = await getFieldsValues(field.list, value?.[i], options);
      resultValue.push([
        {
          page: String(i),
          fields,
        },
      ]);
    }
  }
  return { value: resultValue };
}

function defaultHandler(_, value) {
  return { value };
}

async function handleImgListField(field, value, options) {
  const resultValue = await options?.notifyUploadItems?.(field.idInput, value);
  return {
    value: resultValue,
  };
}

const baseHandlers = Object.values(mobileFormFieldsTypes).reduce((acc, item) => {
  acc[item.id] = {
    resultType: item.value,
    typeAction: item.typeAction,
    handler: defaultHandler,
  };
  return acc;
}, {});

const fieldHandlers = {
  ...baseHandlers,
  [mobileFormFieldsTypes.text.id]: { resultType: mobileFormFieldsTypes.text.value, handler: handleTextField },
  [mobileFormFieldsTypes.textArea.id]: { resultType: mobileFormFieldsTypes.textArea.value, handler: defaultHandler },
  [mobileFormFieldsTypes.radios.id]: { resultType: mobileFormFieldsTypes.radios.value, handler: handleRadioField },
  [mobileFormFieldsTypes.list.id]: { resultType: mobileFormFieldsTypes.list.value, handler: handleListField },
  [mobileFormFieldsTypes.checkbox.id]: {
    resultType: mobileFormFieldsTypes.checkbox.value,
    handler: defaultHandler,
  },
  [mobileFormFieldsTypes.checkboxGroup.id]: {
    resultType: mobileFormFieldsTypes.checkboxGroup.value,
    handler: handleCheckboxField,
  },
  [mobileFormFieldsTypes.asset.id]: { resultType: mobileFormFieldsTypes.asset.value, handler: handleAssetField },
  [mobileFormFieldsTypes.imgList.id]: { resultType: mobileFormFieldsTypes.imgList.value, handler: handleImgListField },
  [mobileFormFieldsTypes.action.id]: { resultType: mobileFormFieldsTypes.action.value, handler: handleActionField },
  [mobileFormFieldsTypes.loop.id]: { resultType: mobileFormFieldsTypes.loop.value, handler: handleLoopField },
  [mobileFormFieldsTypes.header.id]: { resultType: mobileFormFieldsTypes.header.value, handler: defaultHandler },
  [mobileFormFieldsTypes.radio.id]: { resultType: mobileFormFieldsTypes.radio.value, handler: defaultHandler },
  [mobileFormFieldsTypes.barcodeScan.id]: {
    resultType: mobileFormFieldsTypes.barcodeScan.value,
    handler: defaultHandler,
  },
};
